import { QuestionAbandonment } from '@/domain/model/form-analytics'

export const MOCK_TOP_DROPOFF_DATA = (): QuestionAbandonment[] => {
  return Array.from({ length: 2 }, (_, index) => ({
    question_id: index,
    name: 'Multiple Choice',
    input_field_id: null,
    drop_off_count: 21,
    drop_off_rate: 0.14,
    avg_time: 13.61,
  }))
}
